export default __webpack_public_path__ + "static/media/spacesticker1.0f4b4fae.png";